import { connect } from 'react-redux';
import { SideBlock } from '../components/side_block';
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentPhase: state.MVKState.phase
  };
};
export var SideBlockContainer = connect(mapStateToProps)(SideBlock);